<template>
  <v-dialog
    v-model="internalShow"
    max-width="1500px"
    class="drawflow-log-dialog"
  >
    <v-card>
      <v-card-title>
        Logs
      </v-card-title>
      <v-card-text>
        <v-container>
          <p class="body-1" v-html="sanitizedLogs"></p>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="green darken-1"
          @click="internalShow = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    logs: {
      type: String,
      default: "No Logs",
    }
  },
  data() {
    return {
      internalShow: this.show,
    }
  },
  computed: {
    sanitizedLogs() {
      return DOMPurify.sanitize(this.logs);
    },
  },
  watch: {
    show(newShow) {
      this.internalShow = newShow;
    },
    internalShow(newShow) {
      this.$emit('update:show', newShow);
    }
  },
}
</script>
<style lang="scss" scoped>
.drawflow-log-dialog {
  background: white;
}

.logs-dialog-card {
  background-color: white !important; /* Force white background */
  opacity: 1 !important; /* Ensure full opacity */
}

.logs-dialog-title {
  background-color: #f5f5f5; /* Light grey background for title */
}

.logs-dialog-content {
  max-height: 70vh; /* Limit height and add scroll if needed */
  overflow-y: auto;
}
</style>